import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { filterDuplicates, filterInstances, MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import { ComponentSync, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend/index';
import { checkIfPathwayElementChanged, getAllResolutionFunctionsVariables, getStatePreconditionsVariables, getTransitionVariables } from '../../../utils.js';
import { ModuleFE_PathwayState } from '../../../../../_entity/pathway-state/index.js';
import { ModuleFE_PathwayTransition } from '../../../../../_entity/pathway-transition/index.js';
export class Section_AllEntityVariables extends ComponentSync {
    __onPathwayTransitionUpdated(...params) {
        if (!this.props.pathwayId && !this.props.pathwayStateId && !this.props.pathwayTransitionId)
            return;
        checkIfPathwayElementChanged(this.state.relevantTransitions, params, (item) => item.pathwayIds?.includes(this.props.pathwayId) || this.props.pathwayTransitionId === item._id || this.props.pathwayStateId === item._id, () => this.reDeriveState(), () => this.reDeriveState());
    }
    __onPathwayStateUpdated(...params) {
        if (!this.props.pathwayId && !this.props.pathwayStateId && !this.props.pathwayTransitionId)
            return;
        checkIfPathwayElementChanged(this.state.relevantStates, params, (item) => item.pathwayIds.includes(this.props.pathwayId) || this.props.pathwayTransitionId === item._id || this.props.pathwayStateId === item._id, () => this.reDeriveState(), () => this.reDeriveState());
    }
    deriveStateFromProps(nextProps, state) {
        state.relevantVariables = this.getConnectedHCSVariables();
        state.relevantStates = ModuleFE_PathwayState.cache.filter(state => state.pathwayIds.includes(nextProps.pathwayId));
        state.relevantTransitions = ModuleFE_PathwayTransition.cache.filter(transition => transition.pathwayIds.includes(nextProps.pathwayId));
        return state;
    }
    getConnectedHCSVariables() {
        //From Spec - "computed based on resolution function and precondition and transitions variables"
        let hcsVariables = {};
        let states = [];
        let transitions = [];
        if (this.props.pathwayId) {
            states = ModuleFE_PathwayState.cache.filter(ps => ps.pathwayIds.includes(this.props.pathwayId));
            transitions = ModuleFE_PathwayTransition.cache.filter(transition => transition.pathwayIds.includes(this.props.pathwayId));
        }
        else if (this.props.pathwayStateId) {
            transitions = ModuleFE_PathwayTransition.cache.filter(transition => transition.sourceId === this.props.pathwayStateId);
            const pathwayState = ModuleFE_PathwayState.cache.unique(this.props.pathwayStateId);
            if (!pathwayState)
                throw new MUSTNeverHappenException(`pathway state with id ${this.props.pathwayStateId} not found`);
            states = [pathwayState];
        }
        else if (this.props.pathwayTransitionId) {
            const transition = ModuleFE_PathwayTransition.cache.unique(this.props.pathwayTransitionId);
            if (!transition)
                throw new MUSTNeverHappenException(`pathway transition with id ${this.props.pathwayTransitionId}`);
            transitions = [transition];
        }
        hcsVariables = {
            ...getStatePreconditionsVariables(states),
            ...getTransitionVariables(transitions),
            ...getAllResolutionFunctionsVariables(filterInstances(transitions.map(transition => transition.resolutionFunctionId)))
        };
        return filterDuplicates(sortArray(Object.values(hcsVariables).flat(), (_variable) => _variable._nameInLowercase), item => item._id);
    }
    render() {
        return _jsx(TS_CollapsableContainerV2, { headerRenderer: _jsxs(_Fragment, { children: [this.state.relevantVariables.length, " HCS Variables"] }), containerRenderer: _jsx(_Fragment, { children: this.state.relevantVariables.map(variable => _jsx("div", { children: variable.name }, variable._id)) }), animated: true });
    }
}
//# sourceMappingURL=Section_AllEntityVariables.js.map